import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'bootstrap/dist/css/bootstrap.min.css';

const testimonials = [
  {
    name: 'Rahul Verma',
    role: 'CTO, Innovix Technologies (India)',
    image: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
    review:
      'We partnered with this team for custom software development. Their agile delivery model and strong communication helped us launch our SaaS product ahead of schedule.',
  },
  {
    name: 'Jessica Collins',
    role: 'Product Manager, SoftSpark Inc. (USA)',
    image: 'https://cdn-icons-png.flaticon.com/512/3135/3135789.png',
    review:
      'Exceptional work on our mobile app project. From UI design to backend API integration, everything was seamless. Highly professional and reliable.',
  },
  {
    name: 'Siddharth Mehra',
    role: 'Founder, CodeWaves Solutions (India)',
    image: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
    review:
      'Their software consulting helped us optimize our microservices architecture. Performance improved significantly, and we’ve seen fewer production issues since.',
  },
  {
    name: 'Michael Reed',
    role: 'Engineering Lead, PixelDynamics (USA)',
    image: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
    review:
      'The team helped us scale our legacy platform to the cloud. Their DevOps practices were rock solid, reducing our deployment time by over 60%.',
  },
  {
    name: 'Aishwarya Iyer',
    role: 'Head of AI/ML, DataVision Labs (India)',
    image: 'https://cdn-icons-png.flaticon.com/512/3135/3135823.png',
    review:
      'They built our entire AI/ML data pipeline — from model training to deployment. Their knowledge of MLOps really accelerated our product delivery.',
  },
  {
    name: 'Daniel Foster',
    role: 'Director of IT, CloudNova Inc. (USA)',
    image: 'https://cdn-icons-png.flaticon.com/512/3135/3135789.png',
    review:
      'Reliable, proactive, and technically sound. Their cloud migration support saved us thousands in infrastructure costs while improving system performance.',
  },
];

const Testimonial = () => {
  return (
    <section className="py-5 bg-light text-dark">
      <div className="container">
        <div className="text-center mb-5">
          <h6 className="text-primary fs-5">Testimonial</h6>
          <h2 className="fw-bold display-6">What Clients Say About Our Software Services</h2>
        </div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          navigation
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
          }}
        >
          {testimonials.map((t, i) => (
            <SwiperSlide key={i}>
              <div
                className="card h-100 shadow-sm"
                style={{
                  minHeight: '380px',
                  height: '100%',
                  width: '100%',
                  paddingBottom: '1rem',
                }}
              >
                <div className="d-flex align-items-center p-4">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="rounded-circle me-3"
                    style={{ width: '75px', height: '75px', objectFit: 'cover' }}
                  />
                  <div>
                    <h5 className="mb-0 fw-semibold fs-5">{t.name}</h5>
                    <small className="text-muted fs-6">{t.role}</small>
                  </div>
                </div>
                <div className="px-4">
                  <div className="text-warning mb-2 fs-6">
                    {[...Array(5)].map((_, i) => (
                      <i className="fa-solid fa-star me-1" key={i}></i>
                    ))}
                  </div>
                  <p className="text-secondary fs-6" style={{ minHeight: '140px' }}>{t.review}</p>
                </div>
                <div className="text-end pe-4">
                  <img
                    src="assets/img/icon/testi-quote.svg"
                    alt="quote"
                    style={{ height: '30px' }}
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonial;
